<template>
    <div class="instruct-page">
        <van-nav-bar :title="navTitle[type]" :fixed="true" left-text="返回" :border="true" left-arrow @click-left="backPage" />
        <img class="instruct-img" :src="imgUrl[type]" background-size="cover"/>
        <div class="content-box">
            <p class="content-text">{{contentText[type]}}</p>
        </div>
        <div class="btn-box">
            <van-button round type="info" @click="save">{{btnText[type]}}</van-button>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    data() {
        return {
            type:'restart',//指令类型
            imgUrl:{
                restart:require('@/assets/images/more_restart.png'),
                shutdown:require('@/assets/images/more_shutdown.png')
            },
            navTitle:{
                restart:'设备远程重启',
                shutdown:'设备远程关机'
            },
            contentText:{
                restart:'提示：远程重启时，请保持设备处于开机联网状态；',
                shutdown:'提示：远程关机时，请保持设备处于开机联网状态；'
            },
            btnText:{
                restart:'远程重启',
                shutdown:'远程关机'
            }
        };
    },
    created() {
        this.type = this.$route.query.data
    },
    mounted() {
        document.getElementsByTagName("body")[0].className = "color-body";
    },
    methods: {
        /**
        * 返回上一级
        */
        backPage() {
            this.$router.back(-1);
        },
        /**
         * 发送指令
         */
        save(){
        let obj = {
            restart:'远程重启',
            shutdown:'远程关机'
        }
        let objType = {
            restart:'sendRemoteReset',
            shutdown:'sendRemoteShutdown'
        }
        let data = {
            ver:1,
            method:objType[this.type],
            imei:this.imei,
            instructionId: this.$intfilter.instructFilter(obj[this.type]),

        }
        this.$http.get(this.$api.userInfo.POST_APPLET,data).then(res => {
            if (res.code === 0) {
                this.$toast({
                    message: "指令发送成功",
                    duration: 2000,
                    icon: require('@/assets/images/safety-fence/correct.png'),
                });
            } else {
                this.$toast({
                    message: res.msg,
                    duration: 2000,
                    icon: require('@/assets/images/safety-fence/wrong.png'),
                });
            }
        })
        }
    },

    watch: {

    },

    beforeDestroy() {
        // document.body.removeAttribute("class", "color-body");
    },
};
</script>

<style lang="scss" scoped>
.instruct-page{
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 120px;
}
.instruct-img{
  width: 670px;
  height: 220px;
}
.content-box{
  margin-top: 40px;
  width: 670px;
  height: 220px;
}
.content-text{
  font-size: 26px;
  font-weight: 400;
  color: #999999;
}
.btn-box{
  z-index: 1;
  position: fixed;
  width: 100%;
  padding: 20px 0 50px;
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
}
</style>
<style lang="scss">
// .color-body {
//     background: rgb(242, 244, 248); // 单元格
// }
.instruct-page .van-button{
  margin: 0 auto;
  border: none;
  width: 586px;
  height: 98px;
  background-color: #01ADA9;
}
</style>
